import messagingService from "../api/messagingService";

export const setUserToken = (token) => ({
  type: "SET_USER_TOKEN",
  payload: { token },
});

export const setUser = (user) => ({
  type: "SET_USER",
  payload: { user },
});

export const setUserLanguage = (userLanguage) => ({
  type: "SET_USER_LANGUAGE",
  payload: { userLanguage },
});

export const setLoginProgress = (inProgress) => ({
  type: "SET_LOGIN_PROGRESS",
  payload: { inProgress },
});

function syncLocalUserPresence(status) {
  try {
    const cached = localStorage.getItem("user");
    if (cached && cached.startsWith("{")) {
      const user = JSON.parse(cached);
      if (user && user.id) {
        user.presenceStatus = status;
        localStorage.setItem("user", JSON.stringify(user));
      }
    }
  } catch (e) {
    /* ignore */
  }
}

export const setPresenceStatus = (body) => {
  return async (dispatch) => {
    const status = body && body.status;
    // Kullanıcı seçimi: online / busy / away (çevrimdışı menüde yok)
    if (!["online", "busy", "away"].includes(status)) {
      return;
    }
    // Optimistic UI + localStorage — sayfa yenilense bile doğru görünsün
    dispatch({
      type: "SET_PRESENCE_STATUS",
      payload: { status },
    });
    syncLocalUserPresence(status);

    try {
      await messagingService.setPresenceStatus(body);
    } catch (e) {
      /* ağ hatası: optimistic kaldı; sonraki sync düzeltebilir */
    }
  };
};
